import type { AgentDto } from '@shared/services/apiService/apiService';
import type { SortingAgentColumns } from '@shared/types/admin/agent';

export type SortDirection = 'asc' | 'desc';

const normalizeSortValue = (value: string | null | undefined): string => {
  return (value ?? '').toString().trim().toLowerCase();
};

const isMissingSortValue = (value: string | null | undefined): boolean => {
  const normalized = normalizeSortValue(value);
  return !normalized || normalized === 'n/a' || normalized === 'na';
};

export const compareSortValues = (
  left: string | null | undefined,
  right: string | null | undefined,
  direction: SortDirection,
): number => {
  const leftMissing = isMissingSortValue(left);
  const rightMissing = isMissingSortValue(right);

  if (leftMissing !== rightMissing) {
    return leftMissing ? 1 : -1;
  }

  if (leftMissing && rightMissing) {
    return 0;
  }

  const result = (left ?? '').localeCompare(right ?? '', undefined, {
    sensitivity: 'base',
    numeric: true,
  });

  return direction === 'asc' ? result : -result;
};

export const sortAgentsByColumn = (
  arr: AgentDto[],
  key: SortingAgentColumns,
  direction: SortDirection,
  resolveSortValue: (agent: AgentDto, key: SortingAgentColumns) => string | null | undefined,
): AgentDto[] => {
  return [...arr].sort((a, b) => {
    const left = resolveSortValue(a, key);
    const right = resolveSortValue(b, key);
    return compareSortValues(left, right, direction);
  });
};
